import { doc, setDoc, updateDoc, getDoc, getDocs, collection, addDoc } from "firebase/firestore";
import { db } from "./config";

export const STORES = {
    USERS: "users",
    CONTACT: "contactform",
};

export class Store {
    static async insertWithID(table: string, pk: string, data: Record<string, any>) {
        try {
            await setDoc(doc(db, table, pk), data);
        } catch (error) {
            throw error;
        }
    }

    static async insert(table: string, data: Record<string, any>) {
        try {
            const result = await addDoc(collection(db, table), data);
            return result;
        } catch (error) {
            throw error;
        }
    }

    static async findAll(table: string) {
        try {
            const result = await getDocs(collection(db, table));
            return result;
        } catch (error) {
            throw error;
        }
    }

    static async findOne(table: string, pk: string) {
        try {
            const result = await getDoc(doc(db, table, pk));
            return result;
        } catch (error) {
            throw error;
        }
    }

    static async update(table: string, pk: string, data: Record<string, any>) {
        try {
            await updateDoc(doc(db, table, pk), data);
        } catch (error) {
            throw error;
        }
    }
}
